<template>
  <div style="display: flex;margin-bottom: 60px;">
    <div>
      <personalMenu :activeIndex="'7'"/>
    </div>
    <div class="coins">
      <div>
        <div class="title-div">
          <img style=" position: absolute;height: 118px;width: 118px;right: 15px"
               src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/personalCenter/img_yaogongbi@2x.png">
          <div style="padding: 10px 15px 15px 15px">
            <div>
              我的零工豆
              <span class="coins-num"> {{ coin }}</span>
            </div>
            <div>
              零工豆可用于拨打电话、信息置顶
            </div>
          </div>
        </div>

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!--el-tab-pane label="获取方式" name="0">
            <el-row gutter="15">
              <el-col :span="8">
                <div class="card-div">
                  <div class="card-title">现金充值</div>
                  <div class="card-info">充值越多，折扣越大</div>
                  <div class="card-btn">
                    <el-button style="color: #096CEFFF;background: #FFFFFFFF;border-color: #096CEFFF;padding: 8px 30px"
                               size="mini" round plain>去充值
                    </el-button>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="card-div">
                  <div class="card-title">积分兑换</div>
                  <div class="card-info">积分可兑换邀工币</div>
                  <div class="card-btn">
                    <el-button style="color: #096CEFFF;background: #FFFFFFFF;border-color: #096CEFFF;padding: 8px 30px"
                               size="mini" round plain>去兑换
                    </el-button>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="card-div">
                  <div class="card-title">实名认证免费领取</div>
                  <div class="card-info">在徐州零工市场AAP上完成身份实名认证即可赠送15个邀工币</div>
                  <div class="card-btn">
                    <el-button style="color: #096CEFFF;background: #FFFFFFFF;border-color: #096CEFFF;padding: 8px 30px"
                               size="mini" round plain @click="tipShow= true">去认证
                    </el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane-->

          <el-tab-pane label="获取记录" name="1">
            <div v-if="list.length>0">
              <div class="hist-div" v-for="item in list">
                <div style="width: 100%;">
                  <div class="hist-title">{{ item.operate }}</div>
                  <div class="hist-time"><i class="el-icon-time"></i>{{ item.createTime }}</div>
                </div>
                <div class="hist-num" style="text-align: center">
                  +<span>{{ item.coin }}</span>
                </div>
              </div>

              <pagination
                v-show="total>0"
                :total="total"
                layout="prev, pager, next"
                :background="false"
                :page.sync="pageNum"
                :limit.sync="pageSize"
                @pagination="coinRecord"
              />
            </div>

            <div v-else class="noContent">
              <img src="../../../assets/img/public/empty_icon.png">
              <div style="width: 100%; text-align: center">暂无内容</div>
            </div>

          </el-tab-pane>
          <el-tab-pane label="使用记录" name="2">
            <div v-if="list1.length>0">
              <div class="hist-div" v-for="item in list1">
                <div style="width: 100%;">
                  <div class="hist-title">{{ item.operate }}</div>
                  <div class="hist-time"><i class="el-icon-time"></i>{{ item.createTime }}</div>
                </div>
                <div class="hist-num" style="text-align: center">
                  -<span>{{ item.coin }}</span>
                </div>
              </div>

              <pagination
                v-show="total>0"
                :total="total"
                layout="prev, pager, next"
                :background="false"
                :page.sync="pageNum1"
                :limit.sync="pageSize"
                @pagination="coinRecord1"
              />
            </div>

            <div v-else class="noContent">
              <img src="../../../assets/img/public/empty_icon.png">
              <div style="width: 100%; text-align: center">暂无内容</div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <el-dialog
        title="温馨提示"
        :visible.sync="tipShow"
        width="30%"
        center>
        <div style="text-align: center">
        <span style="font-size: 16px">发布招工信息、发布找活广告需实名认证
          <br>扫码下载徐州零工市场APP，在APP完成实名认证</span>
        </div>

      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getNo,
  coinRecord
} from '@api/coins'
import personalMenu from "@views/layout/components/personalMenu";

export default {
  name: 'coins',
  components: {
    personalMenu
  },
  data() {
    return {
      tipShow: false,
      total: 0,
      activeName: '1',
      coin: 0,
      pageNum: 0,
      pageNum1: 0,
      pageSize: 5,
      list: [],
      list1: []
    }
  },
  created() {
    this.getNo()
    // this.coinRecord()
    this.coinRecord('1')
  },
  mounted() {
  },
  methods: {

    handleClick(tab) {
      this.pageNum = 0
      this.pageNum1 = 0
      if (tab.name === '1') {
        this.coinRecord(tab.name)
      } else if (tab.name === '2') {
        this.coinRecord1(tab.name)
      }
      console.log('tab.name', tab.name)
    },

    getNo: function () {
      getNo().then(res => {
        if (res.data.code == 200) {
          this.coin = res.data.data.coin
        }
      })
    },

    coinRecord() {
      coinRecord({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: 1
      }).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.data.rows
          this.total = res.data.data.totalRows
        }
      });
    },

    coinRecord1() {
      coinRecord({
        pageNum: this.pageNum1,
        pageSize: this.pageSize,
        type: 2
      }).then(res => {
        if (res.data.code === 200) {
          this.list1 = res.data.data.rows
          this.total = res.data.data.totalRows
        }
      });
    },

    viewOrg(item) {
      this.enterRouter('coinsInfo', {id: item.id})
      // this.$router.push('/personalCenter/coins/info')
    },
  }
}
</script>

<style lang="scss">
.el-pagination button {
  min-width: 20px;
  height: 20px;
  line-height: 20px;
}

.el-pager li {
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  margin: 0 10px;
  font-size: 14px;
}

.el-pager li.active {
  background: #096cef;
  color: #fff;
}

.el-tabs__nav-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0;
  background-color: #E4E7ED;
  z-index: 1;
}

.el-tabs__header {
  margin-left: 20px;
}

.el-tabs__item {
  font-size: 16px;
}

.coins {
  border-radius: 5px;
  padding: 20px;
  margin-left: 10px;
  width: 990px;
  margin-top: 20px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 20px #e6e6e6;

  .title-div {
    position: relative;
    height: 125px;
    width: 100%;
    background: #EFF6FF;
    border-radius: 6px 6px 6px 6px;
    margin-bottom: 20px;
    //padding: 15px;

    .coins-num {
      vertical-align: -10%;
      font-size: 40px;
      font-weight: bold;
      color: #096CEF;
      padding-left: 15px;
      line-height: 70px;
    }
  }

  .card-div {
    padding: 24px;
    width: 100%;
    height: 135px;
    background-color: #F9F9F9FF;
    border-radius: 5px;
    position: relative;

    .card-title {
      font-weight: bold;
    }

    .card-info {
      font-size: 14px;
      padding-top: 8px;
    }

    .card-btn {
      position: absolute;
      bottom: 24px;
      right: 24px;
    }
  }

  .hist-div {
    padding: 15px;
    display: flex;
    background-color: #F9F9F9FF;
    border-radius: 5px;
    margin-bottom: 10px;

    .hist-title {
      font-weight: bold;
    }

    .hist-time {
      padding-top: 10px;
      font-size: 14px;
      color: #999999FF;
    }

    .hist-num {
      font-size: 30px;
      margin: auto;

      span {
        color: #FFB111FF;
      }
    }
  }
}

</style>
